import { Action, createReducer, on } from '@ngrx/store';
import { Meeting } from '../../meeting';
import * as MeetingAttendeesActions from './meeting-attendees.actions';

export const MEETINGATTENDEES_FEATURE_KEY = 'meetingAttendees';

export interface State {
  meetingId: string | number;
  meeting: Meeting,
  loaded: boolean; 
  error: string | null;
  email: string;
}

export interface MeetingAttendeesPartialState {
  readonly [MEETINGATTENDEES_FEATURE_KEY]: State;
}

export const initialState: State = {
  loaded: true,
  meetingId: null,
  meeting: null,
  error: null,
  email: null
}

const meetingAttendeesReducer = createReducer(
  initialState,
  on(MeetingAttendeesActions.clearStore, (state) => ({
    ...initialState
  })),
  on(MeetingAttendeesActions.loadMeeting, (state, { email, meetingId }) => ({
    ...state,
    loaded: false,
    error: null,
    meetingId,
    email
  })),
  on(MeetingAttendeesActions.loadMeetingSuccess, (state, { meeting }) => ({
    ...state,
    loaded: true,
    meeting,
    error: null
  })),
  on(MeetingAttendeesActions.loadMeetingFailure, (state, { error }) => ({
    ...state,
    loaded: true,
    error
  }))
);

export function reducer(state: State | undefined, action: Action) {
  return meetingAttendeesReducer(state, action);
}
